export enum PermissionType {
  view,
  create,
  edit,
  delete,
}
